import { render, staticRenderFns } from "./RewardsGreeting.vue?vue&type=template&id=0be9a19a&scoped=true"
import script from "./RewardsGreeting.vue?vue&type=script&lang=js"
export * from "./RewardsGreeting.vue?vue&type=script&lang=js"
import style0 from "./RewardsGreeting.vue?vue&type=style&index=0&id=0be9a19a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9a19a",
  null
  
)

export default component.exports